import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponseWithPagination,
  SupportConversationTicketsResponseDataSchema,
  SupportSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof SupportSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof SupportConversationTicketsResponseDataSchema>
>

export const getConversationTicketsQueryKey = (query?: Query) => ["support", "tickets", query]

type Props = {
  query?: Query
  onSuccess?: (data: Response) => void
}

export const conversationTicketsQuery = ({ query, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getConversationTicketsQueryKey(query),
    queryFn: async () => {
      const response = await axios.get<Response>("/support/tickets", { params: query })

      onSuccess?.(response.data)

      return response.data.data
    },
  })
}
